<template>
  <div class="industryMap">
    <Header @getLoginInfo="getLoginInfoFn"></Header>

    <el-container style="height: auto;">
      <!-- 左侧部分 -->
      <el-aside
        class="leftBox"
        width="240px"
        style="overflow: hidden;box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);margin-right:30px;border-right: 1px solid #08396A;border-bottom: 1px solid #08396A;background: rgba(5, 43, 79, 0.3);position:relative;"
      >
        <div class="left_buttonBox" style="display:none;">
          <div class="btn1 active" @click="changeFirstTab('企业数量')">
            企业数量
          </div>
          <div class="btn2" @click="changeFirstTab('注册资本')">注册资本</div>
        </div>

        <!-- 左侧树形图 -->
        <singleChoseTree
          v-if="tree.data"
          :treeData="tree.data"
          :checked="tree.changSelectedData"
          @treeCurrentCheckedData="treeCurrentCheckedData"
          style="width:220px;margin:28px auto 0;background: rgba(255,255,255,0);"
        ></singleChoseTree>

        <div
          v-if="!ifLogin || !ifRights"
          @click="clickMasker"
          class="left_masker"
        ></div>
      </el-aside>
      <!-- 右侧部分 -->
      <el-container style="margin-right: 20px;overflow:hidden;">
        <!-- 面包屑 -->
        <div style="width:100%;overflow:hidden;">
          <div class="underHeader">
            <img :src="forms.local" style="width:12px;display:inline-block;" />
            当前位置：
            <a href="/#/index">平台首页 ></a>
            产业地图
          </div>
        </div>

        <!-- 条件搜索部分 -->
        <el-header
          style="text-align: right; font-size: 12px;height:158px;box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);background: rgba(5, 43, 79, 0.3);padding:0;position:relative;"
        >
          <el-form
            id="r_form_box"
            :label-position="forms.labelPosition"
            label-width="80px"
            :model="forms.formLabelAlign"
            style="border-right: 1px solid #08396A;"
          >
            <el-form-item
              size="medium"
              style="margin-bottom:0;border-top: 1px solid #08396A;background: rgba(255, 255, 255, 0);margin-left:0;"
            >
              <div
                style="float:left;width:138px;height:38px;text-align:center;line-height:38px;color: #DFECF7;border-right: 1px solid #08396A;border-left: 1px solid #08396A;"
              >
                登记状态
              </div>
              <el-radio-group
                v-model="forms.radio1"
                size="medium"
                fill="rgba(255, 255, 255, 0)"
                style="float:left;margin-top: 2px;"
              >
                <el-radio-button label="全部状态"></el-radio-button>
                <el-radio-button
                  v-for="(item, i) in forms.state"
                  :label="item.showName"
                  :key="i"
                ></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              size="medium"
              style="margin-bottom:0;border-top: 1px solid #08396A;"
            >
              <div
                style="float:left;width:138px;height:38px;text-align:center;line-height:38px;color: #DFECF7;border-right: 1px solid #08396A;border-left: 1px solid #08396A;"
              >
                注册资本
              </div>
              <el-radio-group
                v-model="forms.radio2"
                size="medium"
                fill="rgba(255, 255, 255, 0)"
                style="float:left;margin-top: 2px;"
              >
                <el-radio-button label="全部资本"></el-radio-button>
                <el-radio-button label="0-100万"></el-radio-button>
                <el-radio-button label="100-500万"></el-radio-button>
                <el-radio-button label="500-1000万"></el-radio-button>
                <el-radio-button label="1000-3000万"></el-radio-button>
                <el-radio-button label="3000-5000万"></el-radio-button>
                <el-radio-button label="5000万以上"></el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              size="medium"
              style="margin-bottom:0;border-top: 1px solid #08396A;"
            >
              <div
                style="float:left;width:138px;height:38px;text-align:center;line-height:38px;color: #DFECF7;border-right: 1px solid #08396A;border-left: 1px solid #08396A;"
              >
                成立时间
              </div>
              <el-radio-group
                v-model="forms.radio3"
                size="medium"
                fill="rgba(255, 255, 255, 0)"
                style="float:left;margin-top: 2px;"
              >
                <el-radio-button label="全部时间"></el-radio-button>
                <el-radio-button label="0-1年"></el-radio-button>
                <el-radio-button label="1-3年"></el-radio-button>
                <el-radio-button label="3-5年"></el-radio-button>
                <el-radio-button label="5-10年"></el-radio-button>
                <el-radio-button label="10年以上"></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              size="medium"
              style="margin-bottom:0;border-top: 1px solid #08396A;border-bottom: 1px solid #08396A;"
            >
              <div
                style="float:left;width:138px;height:38px;text-align:center;line-height:38px;color: #DFECF7;border-right: 1px solid #08396A;border-left: 1px solid #08396A;"
              >
                所属行业
              </div>
              <el-cascader
                ref="industry"
                collapse-tags
                v-model="forms.radio4"
                :props="forms.props"
                :options="forms.industryData"
                @expand-change="expandChange"
                :show-all-levels="false"
                style="float:left;margin-top: 2px;margin-left:19px;width:200px;"
                placeholder="请输入关键字，如：软件"
                size="small"
              >
              </el-cascader>
            </el-form-item>
          </el-form>
          <div
            v-if="!ifLogin || !ifRights"
            @click="clickMasker"
            class="left_masker"
          ></div>
        </el-header>

        <el-main
          style="margin-top:8px;box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1); border:1px solid #08396A;padding:0;background: rgba(5, 43, 79, 0.3);"
        >
          <div class="tag-group">
            <span class="tag-group__title">已选条件：</span>
            <el-tag
              style="margin-left:8px;color:#fff;border-radius:0;"
              size="medium"
              v-for="item in items"
              :key="item.value + Math.random()"
              :type="item.type"
              :closable="
                item.value[0] == 'selectResult' ||
                item.label == '全部状态' ||
                item.label == '全部资本' ||
                item.label == '全部时间' ||
                (item.value[0] == 'titleCodes' && item.value[2] == 0)
                  ? false
                  : true
              "
              disable-transitions
              color="#177FE8"
              @close="closeTags(item)"
              effect="dark"
            >
              {{ item.label }}
            </el-tag>
            <!-- <el-switch
                            style="margin-left:20px;"
                            v-model="forms.value1"
                            active-color="#3C98F5"
                            inactive-color="#3C98F5"
                            active-text="期末实有"
                            inactive-text="新增">
                        </el-switch> -->
            <div class="closeUp">{{ !ifClose ? "折叠" : "展开" }}</div>
          </div>
          <el-row style="margin-top:32px;padding:0 20px;">
            <div
              v-show="maps.provinceName"
              id="returnBackBtn"
              class="returnPrevMap"
            >
              上级地图
            </div>

            <div class="returnImgDown">地图导出</div>

            <div class="mapTitle btn-shine"></div>
            <!-- 显示当前数据标签 -->
          </el-row>
          <div style="position:relative;width:100%;height:650px;">
            <div
              v-show="!maps.showTMap"
              id="main1"
              style="width: 97%;height:100%;margin:0 auto;"
            ></div>
            <!-- <gaoMap
              v-if="maps.showTMap"
              :jsonStr="maps.tianMapJson"
              style="width: 97%;height:97%;margin:2% auto 0;"
            ></gaoMap> -->
          </div>
          <div
            id="bar_line_box"
            style="width: 97%;height:250px;margin:20px auto 0;"
          ></div>
          <el-image
            style="width: 41px;height: 41px;position:relative;bottom:37px;left:13px;cursor:point;"
            @click="playMapFn"
            :src="maps.ifPlay ? maps.pauseBtn : maps.playBtn"
          ></el-image>
          <!-- <div id="time_line_box" style="width: 97%;height:50px;margin:0 auto;"></div> -->
        </el-main>
      </el-container>
    </el-container>
    <Footer style="margin-top:25px;"></Footer>
  </div>
</template>
<script>
import "@/../static/plugins/chinese-map/static/css/main.css";
import echarts from "echarts";
import cityMap from "@/../static/plugins/chinese-map/static/js/citymap.js";
import $ from "jquery";
import magic from "@/../static/common/magic.js";

// import gaoMap from "@/components/gaoMap.vue";
import singleChoseTree from "@/components/singleChoseTree.vue";

import Header from "@/components/header";
import Footer from "@/components/footer";

import playBtn from "@/assets/map/playBtn.png";
import pauseBtn from "@/assets/map/pauseBtn.png";
import local from "@/assets/map/local.png";

export default {
  data() {
    let _self = this;
    return {
      forms: {
        //上边搜索框的依赖
        local, //图片
        labelPosition: "right",
        formLabelAlign: {
          name: "",
          region: "",
          type: ""
        },
        radio1: "全部状态", //登记状态
        radio2: "全部资本", //注册资本
        radio3: "全部时间", //成立时间
        radio4: "", //所属行业选中项
        value1: true, //总量增量选项,true为总量total_quantity，false为增量increment_quantity
        industryData: [], //所属行业数据-第一级
        industryData2: [], //所属行业数据-二三级
        state: [], //登记状态全部后台数据
        props: {
          // lazy: true,
          multiple: true,
          children: "childrenList",
          value: "industry_id",
          label: "industry_name"
          // lazyLoad (node, resolve) {
          //     const level = node.level;
          //     const id = node.value;
          //     api.imap_getNextIndustryDot(id).then(res=>{

          //         let _industry = res.data;
          //         let node = _self.changeBool(_self, _industry, 'leaf');
          //         for(let i=0;i<_industry.length;i++){
          //             _self.forms.industryData2.push(_industry[i]);
          //         }
          //         resolve(_industry);
          //     })
          // }
        }
      },
      maps: {
        //地图参数
        showTMap: false, //是否显示天地图
        // 天地图数据
        tianMapJson: [],
        playBtn, //播放按钮图片
        pauseBtn, //暂停按钮图片
        ifPlay: false, //是否播放
        bigNum: 0, //当前地图数据里的最大值
        province: "province", //当前地图在哪一级别全国是province，province/city/district/detail
        provinceName: "", //当前省份的名字，province的时候可以为空
        seriesName: "china", //在点击地图下钻时添加，记住当前的级别，方便切换条件的时候还能加载当前级别
        provinceData: [], //因为省级的数据是带省市自治区的，下面已经被我去掉了，在此保存一下，将带省市拿来传给后台当参数用,否则不管用
        stashArry: [], //记住每一级地图的名字，为返回上一级做准备
        start: "", //柱状图开始时间
        end: "", //柱状图结束时间  "1920-01:2018-12"
        xData: [], //柱状图x周的数据
        _indexStart: "", //柱状图开始坐标
        _indexEnd: "" //柱状图拖拽结束坐标
      },
      tree: {
        //树形图参数
        data: "", //树形图数据
        selectedData: [], //当前选中项
        changSelectedData: {}, //删除选中标签改变tree选中项
        firstSelect: "企业数量", //左侧树上面企业数量和注册资本的切换
        change: 1 //防止改变对象属性时watch不生效
      },
      loginInfo: "", //登录信息
      items: [
        //---------所有条件的已选标签-------------
        { label: "企业数量", value: ["selectResult", "registNum"] }
      ],
      currentIndex: 0, //时间轴当前的下标
      ifRights: false, //判断是否有权限
      ifLogin: false, //判断是否已登录
      ifClose: false //条件搜索框是否展开
    };
  },
  watch: {
    tree: {
      handler(val, oldVal) {
        let _this = this;
        // 过滤掉tree下面的所有数据
        let tmpArr = this.items.filter((ele, i) => {
          return (
            ele["value"][0] != "selectResult" && ele["value"][0] != "titleCodes"
          );
        });
        this.items = tmpArr;

        //value是要传给后台的数据，数组里第一项是key,后面是值
        //企业数量，注册资本按钮点击切换标签
        this.items.push({
          label: val.firstSelect,
          value: [
            "selectResult",
            val.firstSelect == "企业数量" ? "registNum" : "registCapital"
          ]
        });

        //左侧树点击切换

        if (val.selectedData.length > 0) {
          for (let i = 0; i < val.selectedData.length; i++) {
            val.selectedData[i]
              ? _this.items.push({
                  label: val.selectedData[i].title_name,
                  value: ["titleCodes", val.selectedData[i].title_code, i]
                })
              : "";
          }
        }

        this.chinaMap(); //更新地图数据
        this.barAndLine(); //更新柱状图数据
      },
      deep: true //true 深度监听
    },
    forms: {
      handler(val) {
        // 过滤掉forms下面的所有数据
        let tmpArr = this.items.filter((ele, i) => {
          return (
            ele["value"][0] != "management_forms_id" &&
            ele["value"][0] != "registered_capital" &&
            ele["value"][0] != "establishment_time" &&
            ele["value"][0] != "industry_id"
          );
        });
        this.items = tmpArr;

        //登记状态切换
        let forms_id = this.forms.state.filter((ele, i) => {
          return ele.showName == val.radio1;
        });
        this.items.push({
          label: val.radio1,
          value: [
            "management_forms_id",
            forms_id.length ? forms_id[0].orderNum : ""
          ]
        });

        //注册资本切换
        let bigMoney =
          val.radio2 == "全部资本"
            ? ""
            : val.radio2.substring(val.radio2.length - 3) == "万以上"
            ? val.radio2.substring(0, val.radio2.length - 3) + ":100000000"
            : val.radio2
                .substring(0, val.radio2.length - 1)
                .split("-")
                .join(":");
        this.items.push({
          label: val.radio2,
          value: ["registered_capital", bigMoney]
        });

        //成立时间切换
        let timeLine =
          val.radio3 == "全部时间"
            ? ""
            : val.radio3.substring(val.radio3.length - 3) == "年以上"
            ? val.radio3.substring(0, val.radio3.length - 3) + ":100"
            : val.radio3
                .substring(0, val.radio3.length - 1)
                .split("-")
                .join(":");
        this.items.push({
          label: val.radio3,
          value: ["establishment_time", timeLine]
        });

        //所属行业切换
        if (val.radio4.length > 0) {
          let newArr = [];
          for (let i = 0; i < val.radio4.length; i++) {
            newArr.push(val.radio4[i][val.radio4[i].length - 1]);
          }
          let newStr = newArr.join(",");
          newArr.length
            ? this.items.push({
                label: "全部所选行业",
                value: ["industry_id", newStr]
              })
            : "";
          console.log(newArr, "newArr");
        }

        $("#r_form_box .el-cascader-menu__list").css({
          color: "#DFECF7!important"
        });
        this.chinaMap(); //更新地图数据
        this.barAndLine(); //更新柱状图数据
      },
      deep: true //true 深度监听
    }
  },
  components: {
    // gaoMap, //天地图组件
    singleChoseTree, //树形图组件
    Header,
    Footer
  },
  methods: {
    //展开行业数据下拉框
    expandChange(val) {
      // this.params["industry_id"] = this.params["industry_id"].join(",");
    },
    //点击左上角的按钮标签跌换函数
    changeFirstTab(val) {
      this.tree.firstSelect = val;
      $(".btn1").removeClass("active");
      $(".btn2").removeClass("active");
      val == "企业数量"
        ? $(".btn1").addClass("active")
        : $(".btn2").addClass("active");
    },
    //点击删除已选标签
    closeTags(tag) {
      let _this = this;
      let tags = this.items.filter((ele, i) => {
        return ele.label != tag && ele.value[0] != tag.value[0];
      });
      this.items = tags;

      tag.value[0] == "management_forms_id"
        ? (this.forms.radio1 = "全部状态")
        : ""; //登录状态标签初始化
      tag.value[0] == "registered_capital"
        ? (this.forms.radio2 = "全部资本")
        : ""; //注册资本标签初始化
      tag.value[0] == "establishment_time"
        ? (this.forms.radio3 = "全部时间")
        : ""; //成立时间标签初始化
      tag.value[0] == "industry_id" ? (this.forms.radio4 = "") : ""; //所属行业标签初始化
      if (tag.value[0] == "titleCodes") {
        for (let i = 0; i < _this.tree.selectedData.length; i++) {
          if (_this.tree.selectedData[i].title_code == tag.value[1]) {
            _this.tree.selectedData[i] = "";
            let tmp = _this.tree.selectedData;
            _this.tree.selectedData = [];
            _this.tree.selectedData = tmp;
            _this.tree.change = Math.random() * 3000;
            _this.tree.changSelectedData = {};
            _this.tree.changSelectedData = { data: _this.tree.selectedData };
          }
        }
      }
    },
    //点击播放按钮函数
    playMapFn() {
      let _this = this;
      this.maps.ifPlay = !this.maps.ifPlay;

      let data = this.maps.xData;
      let num = 0;
      if (data.length > 0) {
        var timePoint = "";
        clearInterval(window.timer);
        window.timer = setInterval(() => {
          if (this.maps.ifPlay) {
            num++;
            if (_this.maps._indexStart + num <= _this.maps._indexEnd) {
              timePoint = _this.maps._indexStart + num;
            } else {
              timePoint = _this.maps._indexStart;
              num = 0;
            }
            _this.maps.start = data[timePoint];
            _this.maps.end = data[timePoint];
            _this.chinaMap();
          } else {
            clearInterval(window.timer);
            timer = null;
            num = 0;
          }
        }, 3000);
      }
    },
    //获取header返回来的登录信息
    getLoginInfoFn(val) {
      this.loginInfo = val;
    },
    //获取树形图当前选中项
    treeCurrentCheckedData(val) {
      this.tree.selectedData = val;
      this.tree.change = Math.random() * 3000;
    },
    //获取左侧树形图的数据
    treeData() {
      let _this = this;
      api.imap_getTreeData().then(res => {
        let _industry = res.data.industry; //所属行业
        let _leftTreeData = res.data.leftTitles; //左侧树形图数据
        let _management_forms = res.data.management_forms; //标签
        _this.tree.data = _leftTreeData;
        // _this.forms.industryData = _this.changeBool(_this, _industry, 'leaf');
        _this.forms.industryData = _industry;
        _this.forms.state = _management_forms;

        if (_leftTreeData.length > 0) {
          //每一根节点可以只单选一个
          for (let i = 0; i < _leftTreeData.length; i++) {
            _this.tree.selectedData.push("");
          }
        }

        _this.getTreeFirstNode(_this, _leftTreeData); //给左侧树形图添加默认第一个选中节点

        setTimeout(() => {
          $(".el-form-item__content").css({ "margin-left": "0" });
          $("#r_form_box .el-cascader-menu:last-child .el-cascader-node").css({
            color: "#DFECF7!important"
          });
          $("#r_form_box .el-cascader__dropdown").css({
            background: "#023261",
            border: "1px solid #023261"
          });
        }, 10);
      });
    },
    //获取第一个子集node来做默认选中态
    getTreeFirstNode(_this, val) {
      if (val[0].childrenList.length > 0) {
        _this.getTreeFirstNode(_this, val[0].childrenList);
      } else {
        let data = val[0];
        _this.tree.selectedData[0] = data;
      }
    },
    //将leaf里的字符串类型转成bool类型
    changeBool(_this, arr, val) {
      if (arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].childrenList.length) {
            _this.changeBool(_this, arr[i].childrenList, val);
          } else {
            if (arr[i].hasOwnProperty(val)) {
              arr[i][val] = arr[i][val] == "false" ? "" : true;
            }
          }
        }
      }

      return arr;
    },
    //获取地图数据
    getMapsData() {
      let _this = this;
      return new Promise(function(resolve, reject) {
        // "1920-01:2018-12"
        let _start = _this.maps.start != "" ? _this.maps.start : "";
        let _end = _this.maps.end != "" ? _this.maps.end : "";
        let timeRang = _start && _end ? _start + ":" + _end : "";

        let trashArr = Array.from(new Set(_this.maps.stashArry));

        if (!_this.maps.ifPlay) {
          //初始化加载时
          let initStart =
            _this.maps.xData.length > 0
              ? _this.maps.xData[0] +
                "--" +
                _this.maps.xData[_this.maps.xData.length - 1]
              : "";
          $(".mapTitle").html(initStart ? "当前数据时间: " + initStart : ""); //展示当前地图的时间
        } else {
          //点击播放时显示当前数据
          $(".mapTitle").html(
            _start ? "当前数据时间: " + _start : "当前数据时间: " + _end
          ); //展示当前地图的时间
        }

        let params = {
          selectLevel: _this.maps.province, //筛选级别，分三层 默认是省份 province  province/city/district/detail
          selectName:
            _this.maps.province == "province" || _this.maps.province == "city"
              ? _this.changeProvinceName(_this.maps.provinceName)
              : _this.maps.province == "detail"
              ? trashArr[trashArr.length - 2] + "," + _this.maps.provinceName
              : _this.maps.provinceName, //在全国的时候传空,天地图的时候传地区加上一级用逗号分开
          xaxisDateRange: timeRang, //时间默认从目前往前倒五年  "1920-01:2018-12"
          titleCodes: "", //左侧树形图参数--
          selectResult: "", //筛选结果 registNum 企业数量  registCapital  注册资本 (左上角切换按钮)--
          numLevel: _this.forms.value1
            ? "total_quantity"
            : "increment_quantity", //增量还是全量 total_quantity 全量 increment_quantity 增量--
          management_forms_id: "", //登记状态--
          industry_id: "", //所属行业id--
          establishment_time: "", //成立时间--
          registered_capital: "" //注册资本--
        };

        for (let i = 0; i < _this.items.length; i++) {
          if (_this.items[i].value[0] == "titleCodes") {
            params.titleCodes
              ? (params[_this.items[i].value[0]] +=
                  "," + _this.items[i].value[1])
              : (params[_this.items[i].value[0]] += _this.items[i].value[1]);
          } else {
            params[_this.items[i].value[0]] = _this.items[i].value[1];
          }
        }
        setTimeout(() => {
          api.imap_getMapData(params).then(res => {
            let data = res.data.list;
            let values = [];
            if (!data.length) {
              resolve([data, res.data.polyline]);
            }
            if (params.selectLevel == "province") {
              _this.maps.provinceData = data;

              for (let i = 0; i < data.length; i++) {
                if (
                  data[i].name.substring(data[i].name.length - 1) == "省" ||
                  data[i].name.substring(data[i].name.length - 1) == "市"
                ) {
                  values.push({
                    name: data[i].name.substring(0, data[i].name.length - 1),
                    totalNum: data[i].totalNum
                  });
                } else if (
                  data[i].name.substring(data[i].name.length - 3) == "自治区"
                ) {
                  if (data[i].name.substring(0, 3) != "内蒙古") {
                    values.push({
                      name: data[i].name.substring(0, 2),
                      totalNum: data[i].totalNum
                    });
                  } else {
                    values.push({
                      name: data[i].name.substring(0, 3),
                      totalNum: data[i].totalNum
                    });
                  }
                }
              }
              resolve([values, res.data.polyline]);
            } else {
              resolve([data, res.data.polyline]);
            }
          });
        }, 100);
      });
    },
    //获取高德地图的数据
    getGeoJson(adcode) {
      let that = this;
      return new Promise(function(resolve, reject) {
        AMapUI.loadUI(["geo/DistrictExplorer"], DistrictExplorer => {
          var districtExplorer = new DistrictExplorer();
          districtExplorer.loadAreaNode(adcode, function(error, areaNode) {
            if (error) {
              console.error(error);
              return;
            }
            let Json = areaNode.getSubFeatures();
            if (Json.length > 0) {
              resolve({
                UTF8Encoding: false,
                features: Json,
                type: "FeatureCollection"
              });
            } else if (Json.length === 0) {
              let _json = that.geoJson.features.filter(
                item => item.properties.adcode == adcode
              );
              resolve({
                UTF8Encoding: false,
                features: _Json,
                type: "FeatureCollection"
              });
            }
          });
        });
      });
    },
    //中国地图函数
    chinaMap() {
      let _this = this;
      //地图容器
      let chart = echarts.init(document.getElementById("main1"));

      //34个省、市、自治区的名字拼音映射数组
      let provinces = {
        //23个省
        台湾: "taiwan",
        河北: "hebei",
        山西: "shanxi",
        辽宁: "liaoning",
        吉林: "jilin",
        黑龙江: "heilongjiang",
        江苏: "jiangsu",
        浙江: "zhejiang",
        安徽: "anhui",
        福建: "fujian",
        江西: "jiangxi",
        山东: "shandong",
        河南: "henan",
        湖北: "hubei",
        湖南: "hunan",
        广东: "guangdong",
        海南: "hainan",
        四川: "sichuan",
        贵州: "guizhou",
        云南: "yunnan",
        陕西: "shanxi1",
        甘肃: "gansu",
        青海: "qinghai",
        //5个自治区
        新疆: "xinjiang",
        广西: "guangxi",
        内蒙古: "neimenggu",
        宁夏: "ningxia",
        西藏: "xizang",
        //4个直辖市
        北京: "beijing",
        天津: "tianjin",
        上海: "shanghai",
        重庆: "chongqing",
        //2个特别行政区
        香港: "xianggang",
        澳门: "aomen"
      };

      //直辖市和特别行政区-只有二级地图，没有三级地图
      let special = ["北京", "天津", "上海", "重庆", "香港", "澳门"];
      let mapdata = [];
      chart.off("click"); //解决点击事件点击一次调用多次的问题
      //绘制全国/地区地图
      _this.maps.provinceName == ""
        ? loadChinaMap()
        : loadOthersMap({
            name: _this.maps.provinceName,
            seriesName: _this.maps.seriesName
          });

      function loadChinaMap() {
        $.getJSON(
          "@/../static/plugins/chinese-map/static/map/china.json",
          function(data) {
            // _this.getGeoJson(100000).then(data =>{
            _this.maps.provinceName = "";
            _this.maps.seriesName = "";
            _this.maps.province = "province";
            _this.maps.stashArry.push("china"); //记住当前的名称

            //获取当前地图数据值
            _this.getMapsData().then(re => {
              let res = re[0];
              let d = [];
              _this.maps.bigNum = 0;
              for (let i = 0; i < data.features.length; i++) {
                for (let j = 0; j < res.length; j++) {
                  if (res[j].name == data.features[i].properties.name) {
                    d.push({
                      name: data.features[i].properties.name,
                      value: res[j].totalNum ? res[j].totalNum : 0
                    });
                  }
                  res[j].totalNum > _this.maps.bigNum
                    ? (_this.maps.bigNum = res[j].totalNum)
                    : ""; //获取最大值
                }
              }
              mapdata = d;
              //注册地图
              echarts.registerMap("china", data);
              //绘制地图
              renderMap("china", d);
            });
          }
        );
      }

      //天地图的返回按钮返回到全国地图
      $("#returnBackBtn").off("click");
      $("#returnBackBtn").on("click", function() {
        let trashArr = Array.from(new Set(_this.maps.stashArry));

        if (trashArr.length == 2) {
          _this.maps.stashArry = [];
          loadChinaMap();
        } else if (trashArr.length > 2) {
          trashArr = trashArr.slice(0, trashArr.length - 1);
          _this.maps.stashArry = trashArr;
          _this.maps.seriesName = trashArr[trashArr.length - 2];
          _this.maps.provinceName = trashArr[trashArr.length - 1];
          loadOthersMap({
            name: trashArr[trashArr.length - 1],
            seriesName: trashArr[trashArr.length - 2]
          });
        }
        _this.maps.showTMap = false;
      });

      //地图点击事件
      chart.on("click", function(params) {
        // _this.maps.seriesName = params.seriesName;
        // _this.maps.provinceName = params.name;
        // _this.maps.stashArry.push(params.name); //记住当前的名称
        // loadOthersMap(params);
        magic.loginOrRights(2).then(res => {
          if (!res) {
            _this.$message.error("请您登录！");
            return;
          }
          if (res && res.rights == 0) {
            _this.$message.error("您没有权限！");
            return;
          }

          _this.maps.seriesName = params.seriesName;
          _this.maps.provinceName = params.name;
          _this.maps.stashArry.push(params.name); //记住当前的名称
          loadOthersMap(params);

          // 埋点
          try {
            //LogCollection.contents["key"]="value";
            //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
            //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
            LogCollection.send(9);
          } catch (e) {}
        });
      });

      //加载省市县区地图函数
      function loadOthersMap(params) {
        if (params.name in provinces) {
          //如果点击的是34个省、市、自治区，绘制选中地区的二级地图
          if (provinces[params.name] == "taiwan") {
            //台湾不下钻
            return;
          }
          // if(provinces[params.name] == 'heilongjiang'){//台湾不下钻
          //     option.series.series[0].zoom = '0.6';
          //     console.log(option.series[0].zoom,'option.series')
          // }
          $.getJSON(
            "@/../static/plugins/chinese-map/static/map/province/" +
              provinces[params.name] +
              ".json",
            function(data) {
              // _this.getGeoJson(provinces[params.name]).then(data =>{
              echarts.registerMap(params.name, data);
              _this.maps.province = "city";
              //获取当前地图数据值
              _this.getMapsData().then(re => {
                let res = re[0];
                let d = [];
                _this.maps.bigNum = 0;
                for (var i = 0; i < data.features.length; i++) {
                  for (let j = 0; j < res.length; j++) {
                    if (res[j].name == data.features[i].properties.name) {
                      d.push({
                        name: data.features[i].properties.name,
                        value: res[j].totalNum ? res[j].totalNum : 0
                      });
                    }
                    res[j].totalNum > _this.maps.bigNum
                      ? (_this.maps.bigNum = res[j].totalNum)
                      : ""; //获取最大值
                  }
                }
                _this.maps.showTMap = false;
                renderMap(params.name, d);
              });
            }
          );
        } else if (params.seriesName in provinces) {
          //如果是【直辖市/特别行政区】只有二级下钻
          if (special.indexOf(params.seriesName) >= 0) {
            // renderMap('china',mapdata);
            _this.maps.province = "detail";
            //获取当前地图数据值
            _this.getMapsData().then(re => {
              let res = re[0];

              re.push(_this.maps.provinceName);
              _this.maps.tianMapJson = res.length > 0 ? re : [];
              //显示天地图
              // setTimeout(() => {
              //   _this.maps.showTMap = false;
              //   setTimeout(() => {
              //     _this.maps.showTMap = true;
              //   }, 0);
              // }, 300);
            });
          } else {
            //显示县级地图
            $.getJSON(
              "@/../static/plugins/chinese-map/static/map/city/" +
                cityMap[params.name] +
                ".json",
              function(data) {
                // _this.getGeoJson(cityMap[params.name]).then(data =>{
                echarts.registerMap(params.name, data);
                _this.maps.province = "district";

                //获取当前地图数据值
                _this.getMapsData().then(re => {
                  let res = re[0];
                  let d = [];
                  _this.maps.bigNum = 0;
                  for (var i = 0; i < data.features.length; i++) {
                    for (let j = 0; j < res.length; j++) {
                      if (res[j].name == data.features[i].properties.name) {
                        d.push({
                          name: data.features[i].properties.name,
                          value: res[j].totalNum ? res[j].totalNum : 0
                        });
                      }
                      res[j].totalNum > _this.maps.bigNum
                        ? (_this.maps.bigNum = res[j].totalNum)
                        : ""; //获取最大值
                    }
                  }
                  _this.maps.showTMap = false;
                  renderMap(params.name, d);
                });
              }
            );
          }
        } else {
          // renderMap('china',mapdata);
          _this.maps.province = "detail";
          //获取当前地图数据值
          _this.getMapsData().then(re => {
            let res = re[0];
            re.push(_this.maps.provinceName);
            _this.maps.tianMapJson = res.length > 0 ? re : [];
            //显示天地图
            // setTimeout(() => {
            //   _this.maps.showTMap = false;
            //   setTimeout(() => {
            //     _this.maps.showTMap = true;
            //   }, 0);
            // }, 300);
          });
        }
      }

      //初始化绘制全国地图配置
      var option = {
        // backgroundColor: '#fff',
        title: {
          //text: (_this.maps.start ? _this.maps.start + '年' : '') + (_this.maps.provinceName ? _this.maps.provinceName : '中国') +'产业地图',
          // subtext: '三级下钻',
          left: "center",
          textStyle: {
            color: "#fff",
            fontSize: 16,
            fontWeight: "normal",
            fontFamily: "Source Han Sans CN"
          },
          subtextStyle: {
            color: "rgba(225,225,225,0)",
            fontSize: 13,
            fontWeight: "normal",
            fontFamily: "Source Han Sans CN",
            opacity: 0
          }
        },
        grid: {
          //设置canvas内部表格的内距
          x: 50,
          y: 50,
          x2: 50,
          y2: 0,
          borderWidth: 10
        },
        tooltip: {
          trigger: "item",
          // formatter: '{b}： {c}家'
          formatter: (params, ticket, callback) => {
            if (params.value) {
              return `${params.name}：${params.value}家`;
            } else {
              return `${params.name}：${0}家`;
            }
          }
        },
        toolbox: {
          show: false,
          orient: "vertical",
          left: "right",
          top: "top",
          iconStyle: {
            normal: {
              color: "#fff"
            }
          },
          feature: {
            mark: {
              // '辅助线开关'
              show: true
            },
            saveAsImage: {
              //保存为图片。
              show: true, //是否显示该工具。
              type: "png", //保存的图片格式。支持 'png' 和 'jpeg'。
              name: "pic1", //保存的文件名称，默认使用 title.text 作为名称
              backgroundColor: "#ffffff", //保存的图片背景色，默认使用 backgroundColor，如果backgroundColor不存在的话会取白色
              title: "中国地图",
              pixelRatio: 1 //保存图片的分辨率比例，默认跟容器相同大小，如果需要保存更高分辨率的，可以设置为大于 1 的值，例如 2
            }
            // dataView: {readOnly: false},
          }
        },
        animationDuration: 1000,
        animationEasing: "cubicOut",
        animationDurationUpdate: 1000,
        visualMap: {
          min: 0,
          max: 150,
          left: "left",
          top: "bottom",
          text: ["高", "低"],
          calculable: true,
          // seriesIndex: [1],
          inRange: {
            // color: ['#D2EAFF', '#177FE8'],
            // color: ['lightskyblue', 'yellow', 'orangered']
            color: ["#87cefa", "#dfed27", "#e6521b"]
          },
          show: true,
          textStyle: {
            color: ["#DCE5F5"]
          }
        }
      };
      function renderMap(map, data) {
        option.visualMap.max = _this.maps.bigNum + 5;
        option.title.subtext = map;
        option.series = [
          {
            name: map,
            type: "map",
            mapType: map,
            roam: true,
            zoom: 1.2,
            nameMap: {
              china: "中国"
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#999",
                  fontSize: 13
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: "#fff",
                  fontSize: 13
                }
              }
            },
            itemStyle: {
              // normal: {
              //     areaColor: '#D2EAFF',
              //     borderColor: '#043563',
              //     shadowColor: '#043563',
              //     shadowBlur: 10,
              //     borderBlur: 10
              // },
              // emphasis: {
              //     areaColor: '#4499d0',
              // }
              normal: {
                borderColor: "rgba(147, 235, 248, 1)",
                borderWidth: 1,
                areaColor: {
                  type: "radial",
                  x: 0.2,
                  y: 0.2,
                  r: 0.9,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(147, 235, 210, 0)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(147, 235, 210, .1)" // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                },
                // shadowColor: 'rgba(128, 217, 248, 1)',
                shadowColor: "#043563",
                shadowOffsetX: -2,
                shadowOffsetY: 2,
                shadowBlur: 10
              },
              emphasis: {
                areaColor: "#389BB7",
                borderWidth: 0
              }
            },
            data: data
          }
        ];
        //渲染地图
        chart.setOption(option, true);
        option.visualMap.max = 5;
      }
      //点击导出地图按钮导出图片
      $(".returnImgDown").off("click");
      $(".returnImgDown").on("click", () => {
        if (!_this.ifLogin) {
          _this.$message.error("请您登录！");
          return;
        }
        if (!_this.ifRights) {
          _this.$message.error("您没有权限！");
          return;
        }

        var img = new Image();
        img.src = chart.getDataURL({
          type: "png",
          pixelRatio: 2, //放大2倍
          backgroundColor: "#fff"
        });

        img.onload = function() {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL("image/png");

          var a = document.createElement("a");
          // 创建一个单击事件
          var event = new MouseEvent("click");
          // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
          a.download = "产业地图.png" || "产业地图";
          // 将生成的URL设置为a.href属性
          a.href = dataURL;
          // 触发a的单击事件
          a.dispatchEvent(event);
        };
      });
    },
    //柱状图形
    barAndLine() {
      let _this = this;
      let dom = document.getElementById("bar_line_box");
      let myChart = echarts.init(dom);
      let app = {};
      let option = null;

      option = {
        color: ["#2B89DE"],
        title: {
          text:
            _this.tree.firstSelect == "企业数量"
              ? "全国企业登记数量"
              : "全国企业注册资本",
          left: "center",
          textStyle: {
            color: "#fff",
            fontSize: 16,
            fontWeight: "normal",
            fontFamily: "Source Han Sans CN"
          }
        },
        grid: {
          //设置canvas内部表格的内距
          x: 50,
          y: 40,
          x2: 50,
          y2: 50,
          borderWidth: 10
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          },
          formatter: (params, ticket, callback) => {
            return `登记数量：${(params[0].value / 10000).toFixed(4)}万家`;
          }
        },
        toolbox: {
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            // dataView: {show: true, readOnly: false},
            magicType: { show: true, type: ["line"] },
            restore: { show: true },
            saveAsImage: { show: true }
          },
          iconStyle: {
            normal: {
              color: "#fff"
            }
          }
        },
        // legend: {
        //     data: ['蒸发量']
        // },
        dataZoom: [
          {
            type: "slider", //滑动轴
            show: true,
            height: 14,
            bottom: 10,
            borderColor: "transparent",
            backgroundColor: "#002D58",
            // 拖拽手柄样式 svg 路径
            handleIcon:
              "M512 512m-208 0a6.5 6.5 0 1 0 416 0 6.5 6.5 0 1 0-416 0Z M512 192C335.264 192 192 335.264 192 512c0 176.736 143.264 320 320 320s320-143.264 320-320C832 335.264 688.736 192 512 192zM512 800c-159.072 0-288-128.928-288-288 0-159.072 128.928-288 288-288s288 128.928 288 288C800 671.072 671.072 800 512 800z",
            handleColor: "#aab6c6",
            handleSize: 20,
            handleStyle: {
              borderColor: "#aab6c6",
              shadowBlur: 2,
              shadowOffsetX: 1,
              shadowOffsetY: 1,
              shadowColor: "#e5e5e5"
            },
            textStyle: {
              color: "#fff"
            },
            startValue: 0, //距离左侧0刻度的刻度，
            endValue: 40 //距离左侧0刻度的刻度，相当于规定了滑动的范围
          }
        ],
        xAxis: [
          {
            type: "category",
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月"
            ],
            axisPointer: {
              type: "shadow"
            },
            axisLine: {
              lineStyle: {
                color: "#25c3da"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: _this.tree.firstSelect == "企业数量" ? "万家" : "亿元",
            min: 0,
            // max: 250,
            // interval: 50,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff"
              }
            },
            axisLabel: {
              // formatter: _this.tree.firstSelect == '企业数量' ? '{value} k+' : "{value} 亿元",
              formatter: (params, ticket, callback) => {
                if (_this.tree.firstSelect == "企业数量") {
                  return params / 10000;
                } else {
                  return params / 100000000;
                }
              },
              textStyle: {
                color: "#fff"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#2c3d89",
                type: "dotted"
              }
            }
          }
        ],
        series: [
          {
            name:
              _this.tree.firstSelect == "企业数量" ? "登记数量" : "注册资本",
            type: "bar",
            data: [
              25.0,
              34.9,
              67.0,
              23.2,
              25.6,
              76.7,
              135.6,
              162.2,
              32.6,
              20.0,
              6.4,
              3.3
            ],
            barWidth: "40%",
            barGap: "10%", // Make series be overlap
            barCateGoryGap: "10%",
            itemStyle: {
              normal: {
                // color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                //         offset: 0,
                //         color: '#D2EAFF',
                //     },
                //     {
                //         offset: 0.8,
                //         color: '#177FE8',
                //     },
                //     {
                //         offset: 1,
                //         color: '#4577BA',
                //     },
                // ]),
                color: new echarts.graphic.LinearGradient(1, 1, 1, 0, [
                  { offset: 0, color: "#395CFE" },
                  { offset: 1, color: "#2EC7CF" }
                ]),
                // opacity: .8,
                barBorderRadius: [12, 12, 12, 12]
              }
            }
            // markPoint : {
            //     data: [
            //         {
            //             name: '最大值',
            //             type: 'max',
            //         },
            //         {
            //             name: '某个坐标',
            //             coord: [10, 20],
            //             valueIndex: 1,
            //             value:2
            //         },
            //         {coord: [1,6]}
            //     ]
            // },
          }
        ]
      };

      let trashArr = Array.from(new Set(_this.maps.stashArry));

      //获取当前地图数据值
      let params = {
        selectLevel: _this.maps.province, //筛选级别，分三层 默认是省份 province  province/city/district
        selectName:
          _this.maps.province == "province" || _this.maps.province == "city"
            ? _this.changeProvinceName(_this.maps.provinceName)
            : _this.maps.province == "detail"
            ? trashArr[trashArr.length - 2] + "," + _this.maps.provinceName
            : _this.maps.provinceName, //在全国的时候传空
        xaxisDateRange: "", //时间默认从目前往前倒五年
        titleCodes: "", //左侧树形图参数--
        selectResult: "", //筛选结果 registNum 企业数量  registCapital  注册资本 (左上角切换按钮)--
        numLevel: _this.forms.value1 ? "total_quantity" : "increment_quantity", //增量还是全量 total_quantity 全量 increment_quantity 增量--
        management_forms_id: "", //登记状态--
        industry_id: "", //所属行业id--
        establishment_time: "", //成立时间--
        registered_capital: "" //注册资本--
      };
      for (let i = 0; i < _this.items.length; i++) {
        if (_this.items[i].value[0] == "titleCodes") {
          params.titleCodes
            ? (params[_this.items[i].value[0]] += "," + _this.items[i].value[1])
            : (params[_this.items[i].value[0]] += _this.items[i].value[1]);
        } else {
          params[_this.items[i].value[0]] = _this.items[i].value[1];
        }
      }

      api.imap_getBarData(params).then(res => {
        let data = res.data["y-axis"];
        let xData = res.data["x-axis"];
        option.xAxis[0].data = xData;
        option.series[0].data = data;

        _this.maps.xData = xData;

        if (option && typeof option === "object") {
          myChart.setOption(option, true);
        }

        _this.maps._indexStart = 0;
        _this.maps._indexEnd = xData.length - 1;
        //柱状图拖拽事件
        myChart.on("datazoom", function(params) {
          //console.log(params);//里面存有代表滑动条的起始的数字
          let xAxis = myChart.getModel().option.xAxis[0]; //获取axis
          //console.log(xData[xAxis.rangeStart]);//滑动条左端对应在xAxis.data的索引
          //console.log(xData[xAxis.rangeEnd]);//滑动条右端对应在xAxis.data的索引
          // _this.maps.start = xData[xAxis.rangeStart];
          // _this.maps.end = xData[xAxis.rangeEnd];
          _this.maps._indexStart = xAxis.rangeStart;
          _this.maps._indexEnd = xAxis.rangeEnd;
        });
        //柱状图点击事件
        // myChart.getZr().on('click', params => {
        //     let pointInPixel = [params.offsetX, params.offsetY]
        //     if (myChart.containPixel('grid', pointInPixel)) {
        //         let xIndex = myChart.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0]
        //         console.log(xIndex,xIndex)
        //     }
        // })
      });
    },
    //给地图全国一级的名称添加省市自治区的字段
    changeProvinceName(name) {
      let arr = this.maps.provinceData;

      if (arr.length > 0) {
        let tmpArr = arr.filter((ele, i) => {
          if (
            ele.name.substring(ele.name.length - 1) == "省" ||
            ele.name.substring(ele.name.length - 1) == "市"
          ) {
            return ele.name.substring(0, ele.name.length - 1) == name;
          } else if (ele.name.substring(ele.name.length - 3) == "自治区") {
            if (ele.name.substring(0, 3) != "内蒙古") {
              return ele.name.substring(0, 2) == name;
            } else {
              return ele.name.substring(0, 3) == name;
            }
          }
        });
        return tmpArr.length > 0 ? tmpArr[0].name : [];
      }
    },
    timeLineFn(params) {
      let _this = this;
      let timeLine = echarts.init(document.getElementById("time_line_box"));
      let option = {
        timeline: {
          data: params,
          axisType: "category",
          autoPlay: true,
          playInterval: 4000,
          left: "0",
          right: "0",
          bottom: "5%",
          width: "100%",
          //  height: null,
          label: {
            normal: {
              textStyle: {
                color: "rgb(179, 239, 255)"
              }
            },
            emphasis: {
              textStyle: {
                color: "#fff"
              }
            }
          },
          currentIndex: _this.currentIndex,
          symbolSize: 10,
          lineStyle: {
            color: "#3097FE"
          },
          checkpointStyle: {
            borderColor: "#D5EBFF",
            color: "#D5EBFF",
            borderWidth: 2
          },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: {
              color: "#53D9FF",
              borderColor: "#53D9FF"
            },
            emphasis: {
              color: "rgb(58,115,192)",
              borderColor: "rgb(58,115,192)"
            }
          }
        }
      };
      timeLine.setOption(option);
      timeLine.on("timelinechanged", v => {
        _this.currentIndex = v.currentIndex;
        _this.curTime = _this.dataList[_this.currentIndex];
      });
    },
    //权限函数，如果没登录或者没权限会调整状态
    ifHaveRights() {
      let _this = this;
      magic.loginOrRights(2).then(res => {
        if (!res) {
          // _this.$message.error("请您登录！");
          _this.ifLogin = false;
        } else {
          _this.ifLogin = true;
        }
        if (res && res.rights == 0) {
          // _this.$message.error("您没有权限！");
          _this.ifRights = false;
          return;
        } else {
          _this.ifRights = true;
        }
      });
    },
    clickMasker() {
      if (!this.ifLogin) {
        this.$message.error("请您登录！");
        return;
      }
      if (!this.ifRights) {
        this.$message.error("您没有权限！");
        return;
      }
    },
    //点折叠上部分的按钮函数
    closeUp() {
      $(".closeUp").on("click", () => {
        this.ifClose
          ? $(".el-header").css("display", "block")
          : $(".el-header").css("display", "none");
        this.ifClose = !this.ifClose;
      });
    }
  },
  mounted() {
    this.treeData();
    this.chinaMap();
    this.barAndLine();
    this.ifHaveRights();
    this.closeUp();
  }
};
</script>
<style lang="less">
.industryMap {
  width: 100%;
  height: 100%;
  background: url("../../assets/map/bg.jpg") no-repeat top;
  background-size: 100% auto;
}
// 面包屑样式
.underHeader {
  display: inline-block;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #dfecf7;
  overflow: hidden;
  a {
    color: #dfecf7;
  }
}

.left_buttonBox {
  width: 100%;

  text-align: center;
  overflow: hidden;
  margin: 39px auto 0;
  color: #023261;
  .btn1 {
    width: 109px;
    height: 34px;
    font-size: 14px;
    display: inline-block;
    text-align: center;
    line-height: 34px;
    color: #6d84a2;
    background: #023261;
    border-radius: 0px 2px 2px 0px;
    cursor: pointer;
  }
  .btn2 {
    width: 109px;
    height: 34px;
    font-size: 14px;
    display: inline-block;
    text-align: center;
    line-height: 34px;
    color: #6d84a2;
    background: #023261;
    border-radius: 0px 2px 2px 0px;
    cursor: pointer;
    margin-left: -4px;
  }
  .btn1.active,
  .btn2.active {
    width: 109px;
    height: 34px;
    background: #177fe8;
    border-radius: 2px 0px 0px 2px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
}
.tag-group {
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #08396a;
  text-align: left;
}
.tag-group__title {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #dfecf7;
  margin-left: 20px;
}
.returnPrevMap {
  width: 96px;
  height: 32px;
  background: #177fe8;
  border-radius: 2px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #dfecf7;
  line-height: 32px;
  text-align: center;
  float: left;
  cursor: pointer;
}
.mapTitle {
  width: 246px;
  height: 32px;
  border-radius: 2px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #dfecf7;
  line-height: 32px;
  text-align: center;
  float: right;
  margin-right: 33%;
}
.returnImgDown {
  width: 96px;
  height: 32px;
  background: rgba(223, 236, 247, 0);
  border: 1px solid #3c98f5;
  border-radius: 2px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3c98f5;
  line-height: 32px;
  text-align: center;
  float: right;
  margin-left: 11px;
  cursor: pointer;
}
.closeUp {
  width: 96px;
  height: 32px;
  background: rgba(223, 236, 247, 0);
  border: 1px solid #3c98f5;
  border-radius: 2px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3c98f5;
  line-height: 32px;
  text-align: center;
  float: right;
  margin-right: 22px;
  margin-top: 8px;
  cursor: pointer;
}
.returnDataDown {
  width: 96px;
  height: 32px;
  background: rgba(223, 236, 247, 0);
  border: 1px solid #3c98f5;
  border-radius: 2px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3c98f5;
  line-height: 32px;
  text-align: center;
  float: right;
  cursor: pointer;
}

// forms表单部分

#r_form_box .el-radio-button--medium .el-radio-button__inner {
  background: rgba(255, 255, 255, 0);
  border: none;
  border-radius: 0;
  color: #dfecf7;
}
#r_form_box .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  //froms标签选中效果
  color: #177fe8 !important;
}
#r_form_box .el-cascader .el-input .el-input__inner,
#r_form_box .el-cascader .el-input .el-input__inner {
  background: #023261;
  border: 1px solid #023261;
}
#r_form_box .el-cascader-menu:last-child .el-cascader-node {
  color: #dfecf7 !important;
}
#r_form_box .el-cascader__dropdown {
  background: #023261;
  border: 1px solid #023261;
}
.el-switch__label {
  color: #dfecf7;
}
// 左侧树形图样式
.leftBox .el-tree {
  background: rgba(255, 255, 255, 0) !important;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #dfecf7;
}
.leftBox .el-tree-node:focus > .el-tree-node__content {
  background: rgba(255, 255, 255, 0) !important;
}
.leftBox .el-tree-node__content:hover {
  background: rgba(255, 255, 255, 0) !important;
  color: #177fe8;
}
// .leftBox .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
//     background:rgba(255,255,255,0)!important;
// }

.left_masker {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  opacity: 0;
  filter: Alpha(opacity=0);
}

// 文字效果
.btn-shine {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 12px 48px;
  color: #fff;
  background: linear-gradient(to right, #fff 0, #409eff 10%, #fff 20%);
  background-position: 0;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 3s infinite linear;
  animation-fill-mode: forwards;
  -webkit-text-size-adjust: none;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  white-space: nowrap;
}
@-moz-keyframes shine {
  0% {
    background-position: 0;
  }
  60% {
    background-position: 280px;
  }
  100% {
    background-position: 280px;
  }
}
@-webkit-keyframes shine {
  0% {
    background-position: 0;
  }
  60% {
    background-position: 280px;
  }
  100% {
    background-position: 280px;
  }
}
@-o-keyframes shine {
  0% {
    background-position: 0;
  }
  60% {
    background-position: 280px;
  }
  100% {
    background-position: 280px;
  }
}
@keyframes shine {
  0% {
    background-position: 0;
  }
  60% {
    background-position: 280px;
  }
  100% {
    background-position: 280px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/industryMap/index.vue